module.exports = __webpack_public_path__ + "img/key_outlined.54e26b09.svg";